<template>
  <div id="app" class="min-h-screen flex flex-col bg-gray-200">
    <div class="flex-grow bg-cover bg-center bg-no-repeat"  :style="{ backgroundImage: 'url(' + require(`@/assets/formulario.png`) + ')' }">
      <router-view />
    </div>
    <FooterSection />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import FooterSection from '@/components/FooterSection.vue'

export default defineComponent({
  name: 'App',
  components: {
    FooterSection
  }
});
</script>
